// iframe lazy load (runs on full window load)
window.onload = function () {
    var vidDefer = document.getElementsByTagName('iframe');
    for (var i = 0; i < vidDefer.length; i++) {
        if (vidDefer[i].getAttribute('data-src')) {
            vidDefer[i].setAttribute('src', vidDefer[i].getAttribute('data-src'));
        }
    }
};

// scroll to hash target after DOM is loaded
document.addEventListener("DOMContentLoaded", function () {
    var hashVal = window.location.hash;
    if (hashVal !== '' && $(hashVal).length) {
        $('html, body').animate({ scrollTop: $('a[href="' + hashVal + '"]').offset().top - 150 });
    }
});

// autocomplete setup
document.addEventListener("DOMContentLoaded", function () {
    var updateTextbox = function (event, ui) {
        var result = ui.item.value.replace(/<\/?[^>]+(>|$)/g, "");
        $(".nav-togglesearch-text").val(result);
        return false;
    };

    $(".nav-togglesearch-text").autocomplete({
        html: true,
        source: function (request, response) {
            $.ajax({
                url: '/PredictiveSearch/AutoSearch',
                type: "POST",
                dataType: "json",
                data: { Prefix: request.term },
                success: function (data) {
                    if (data == null) return;
                    response($.map(data, function (item) {
                        $('body').addClass("bodyclass");
                        return {
                            label: item.name,
                            value: item.name,
                            image: item.image,
                            link: item.url,
                            summary: item.description
                        };
                    }));
                }
            });
        },
        minLength: 2,
        position: {
            my: "left top+30",
            at: "left-16 bottom+10"
        }
    }).data("ui-autocomplete")._renderItem = function (ul, item) {
        var htmlData = `
            <div class="media product-icon">
                <a href="${item.link}">
                    <img src="${item.image}">
                    <div class="media-body">
                        <span class="result-title">${item.label}</span>
                        <p class="desc">${item.summary}</p>
                    </div>
                </a>
            </div>`;
        return $("<li></li>").data("item.autocomplete", item).html(htmlData).appendTo(ul);
    };
});
